import { render } from "./historyattendance.vue?vue&type=template&id=ce2e2e50"
import script from "./historyattendance.vue?vue&type=script&lang=js"
export * from "./historyattendance.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__